app.controller('projectRequestController', function($http, $scope, $stateParams, $location, dataService, $modal, pageConfig, pageHandler, $timeout, $controller) {

	$scope.showProjectRequest = function()
    {
        var modalInstance = $modal.open({
            templateUrl: 'views\/project_request.html',
            controller: showProjectRequestController,
            scope : $scope,
            windowClass : 'project-request-window'
        });
    }

    //Controller for project request form
    function showProjectRequestController($http, $q, $scope, $modalInstance) {
		$scope.filesize_limit = 20 * 1024 * 1000;
		$scope.filesize_error_text = "Allowed Max Size : 20 MB.";
		$scope.message_error_text = "Message field is required";
        $scope.$watch('file', function() {
            $scope.filename = $scope.file != undefined && $scope.file.name != undefined ? $scope.file.name : '';
        });
        $scope.alert = false;
        $scope.submit = function() {
        	$scope.loading = true;
            var formData = new FormData(document.getElementById('requestForm'));
            $http.post('project_request/save', formData, {
                cache: false,
                contentType: false,
                processData: false,
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            })
			.success(function (response) {
                $scope.loading = false;
				if(response.data.status) {
                    document.getElementById('requestForm').reset();
                    $scope.alert = {
                        type: 'success',
                        message: response.data.message
                    };
                    setTimeout(function() {
                        $modalInstance.close();
                    }, 2000);
				} else {
                    $scope.alert = {
                        type: 'danger',
                        message: response.data.message
                    };
				}
			})
			.error(function (reject) {

			});
		}
        $scope.cancel = function() {
            $modalInstance.dismiss('cancel');
        };
        $scope.closeAlert = function() {
            $scope.alert = false;
		}
    }

});
